import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";

class WSManager {

  client = null;
  connected = false;

  // topic -> [callbacks]
  subscriptions = new Map();

  // topic -> stompSubscription
  activeSubscriptions = new Map();

  connect(backendUrl) {

    if (this.client) return;

    const socket = new SockJS(`${backendUrl}/api/ws`);

    this.client = new Client({
      webSocketFactory: () => socket,

      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,

      onConnect: () => {
        console.log("WS connected");

        this.connected = true;
        this.restoreSubscriptions();
      },

      onWebSocketClose: (event) => {
        console.log("WebSocket closed", event);
        this.connected = false;
        // The underlying socket is dead - its STOMP subscriptions die with
        // it, but this Map never got told that. Left uncleared,
        // restoreSubscriptions() on the NEXT reconnect sees these stale
        // entries and its createSubscription() guard ("already have this
        // topic, skip") silently no-ops for every one of them - the
        // client looks connected again but never actually re-subscribes
        // to anything. `subscriptions` (topic -> desired callbacks) is
        // deliberately left alone - that's what tells restoreSubscriptions
        // what to re-create.
        this.activeSubscriptions.clear();
      },

      onStompError: (frame) => {
        console.error("Broker error:", frame.headers["message"]);
      }

    });

    this.client.activate();
  }

  subscribe(topic, callback) {

    if (!this.subscriptions.has(topic)) {
      this.subscriptions.set(topic, []);
    }

    const handlers = this.subscriptions.get(topic);

    // unikamy duplikatów callbacków
    if (!handlers.includes(callback)) {
      handlers.push(callback);
    }

    // jeśli socket już działa → twórz sub
    if (this.connected) {
      this.createSubscription(topic);
    }

  }

  createSubscription(topic) {

    if (!this.client) return;

    // jeśli już istnieje → nie twórz drugi raz
    if (this.activeSubscriptions.has(topic)) return;

    const handlers = this.subscriptions.get(topic);

    const sub = this.client.subscribe(topic, (msg) => {

      const event = JSON.parse(msg.body);

      handlers.forEach(cb => cb(event));

    });

    this.activeSubscriptions.set(topic, sub);

  }

  unsubscribe(topic, callback) {

    if (!this.subscriptions.has(topic)) return;

    const handlers = this.subscriptions
      .get(topic)
      .filter(cb => cb !== callback);

    if (handlers.length === 0) {

      this.subscriptions.delete(topic);

      const sub = this.activeSubscriptions.get(topic);

      if (sub) {
        sub.unsubscribe();
        this.activeSubscriptions.delete(topic);
      }

    } else {

      this.subscriptions.set(topic, handlers);

    }

  }

  send(destination, body) {

    if (!this.client || !this.connected) {
      console.log("WS not connected");
      return;
    }

    this.client.publish({
      destination,
      body: JSON.stringify(body)
    });

  }

  restoreSubscriptions() {

    this.subscriptions.forEach((_, topic) => {
      this.createSubscription(topic);
    });

  }

  disconnect() {

    if(this.client){
        this.client.deactivate();
        this.client = null;
        this.connected = false;
        this.activeSubscriptions.clear();
    }

    }

}

export default new WSManager();